<template>
  <loading v-if="loading" />
  <error-messages
    v-else-if="!loading && errorMessages.length > 0"
    :show="true"
    :messages="errorMessages"
  />
  <b-row v-else>
    <error-messages
      v-if="!loadingCreateDbManager && errorMessagesCreateDbManager.length > 0"
      :show="showErrorCreateDbManager"
      :dismissible="true"
      @dismissed="dismissedErrorCreateDbManager"
      :messages="errorMessagesCreateDbManager"
    />
    <b-col lg="4" cols="12">
      <b-card class="mb-4" title="اتصال به دیتابیس" title-tag="h5">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            lg="12"
            v-for="(item, i) in connectDbList"
            :key="i"
          >
            <div class="d-flex align-items-center mb-3">
              <b-icon
                :icon="item.icon"
                font-scale="2"
                variant="warning"
                class="ml-3"
              />
              <div class="d-flex flex-column">
                <small class="d-flex mb-2 text-muted">
                  {{ item.type }}
                </small>
                <div v-if="item.id === 'dbManagerName'">
                  <loading-btn
                    v-if="timeout"
                    :loading="loadingCreateDbManager"
                    :disabled="loadingCreateDbManager"
                    size="sm"
                    variant="outline-primary"
                    @click="createDbManager"
                  >
                    فعال کردن db manager
                  </loading-btn>
                  <div v-else class="d-flex flex-column dir-ltr">
                    <a :href="`http://${item.value}.cv9.ir`" target="_blank">
                      {{ item.value + ".cv9.ir" }}
                    </a>
                    <b-badge variant="warning">
                      {{ remainingTime }}
                    </b-badge>
                  </div>
                </div>
                <span v-else>{{ item.value }}</span>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="mb-4" title="منابع انتخاب شده" title-tag="h5">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            lg="12"
            v-for="(item, i) in resourceList"
            :key="i"
          >
            <div class="d-flex align-items-center mb-3">
              <b-icon
                :icon="item.icon"
                font-scale="2"
                variant="warning"
                class="ml-3"
              />
              <div class="d-flex flex-column">
                <small class="d-flex mb-2 text-muted">
                  {{ item.type }}
                </small>
                <span> {{ item.value }}&nbsp;{{ item.unit }} </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col lg="8" cols="12">
      <b-card class="mb-4" title="اطلاعات اصلی" title-tag="h5">
        <b-row>
          <b-col v-for="(item, i) in mainInfoList" :key="i" cols="12" sm="6">
            <div class="d-flex align-items-center mb-3">
              <b-icon
                :icon="item.icon"
                font-scale="2"
                variant="warning"
                class="ml-3"
              />
              <div class="d-flex flex-column">
                <small class="d-flex mb-2 text-muted">
                  {{ item.type }}
                </small>
                <span> {{ item.value }}&nbsp;{{ item.unit }} </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="mb-4" title="اطلاعات بیشتر" title-tag="h5">
        <b-row>
          <b-col v-for="(item, i) in moreInfoList" :key="i" cols="12" sm="6">
            <div class="d-flex align-items-center mb-3">
              <b-icon
                :icon="item.icon"
                font-scale="2"
                variant="warning"
                class="ml-3"
              ></b-icon>
              <div class="d-flex flex-column">
                <small class="d-flex mb-2 text-muted">
                  {{ item.type }}
                </small>
                <span>
                  {{ item.value }}&nbsp;{{ item.unit }}
                  <b-badge
                    v-if="item.id === 'price'"
                    variant="success"
                    to="/payment/add"
                    class="mr-md-2"
                  >
                    افزایش اعتبار
                  </b-badge>
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  userServiceDetails,
  createService,
  getLastServiceVersionId
} from "@/services/service";
import Loading from "@/components/Loading/Loading.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";
import LoadingBtn from "../../../components/LoadingBtn/LoadingBtn.vue";
import { timerMinScound } from "../../../utils/functions";

export default {
  components: { Loading, ErrorMessages, LoadingBtn },
  name: "AppDetails",
  data() {
    return {
      loading: false,
      loadingCreateDbManager: false,
      errorMessages: "",
      showErrorCreateDbManager: false,
      errorMessagesCreateDbManager: [],
      connectDbList: [
        {
          id: "dbManagerName",
          type: "آدرس db manager",
          icon: "link45deg",
          value: ""
        },
        {
          id: "username",
          type: "نام کاربری",
          icon: "person",
          value: "root"
        },
        {
          id: "password",
          type: "رمز عبور",
          icon: "key",
          value: ""
        }
      ],
      resourceList: [
        {
          id: "cpu",
          type: "پردازنده (CPU)",
          icon: "cpu",
          value: "",
          unit: "هسته"
        },
        {
          id: "ram",
          type: "حافظه اصلی (RAM)",
          icon: "border-style",
          value: "",
          unit: "گیگابایت"
        },
        {
          id: "storage",
          type: "فضا (HDD)",
          icon: "hdd",
          value: "",
          unit: "گیگابایت"
        }
      ],
      moreInfoList: [
        {
          id: "price",
          type: "هزینه",
          icon: "cash",
          value: "",
          unit: "ریال ساعتی"
        },
        {
          id: "trafic",
          type: "ترافیک",
          icon: "bar-chart",
          value: "نامحدود",
          unit: ""
        },
        {
          id: "location",
          type: "موقعیت",
          icon: "geo-alt",
          value: "ایران",
          unit: ""
        },
        {
          id: "createdAt",
          type: "تاریج ایجاد",
          icon: "calendar2-check",
          value: "",
          unit: ""
        }
      ],
      mainInfoList: [
        {
          id: "name",
          type: "شناسه",
          icon: "key",
          value: "",
          unit: ""
        },
        {
          id: "version",
          type: "نسخه دیتابیس",
          icon: "collection",
          value: ""
        },
        {
          id: "privateHost",
          type: "هاست خصوصی",
          icon: "tv",
          value: ""
        },
        {
          id: "privatePort",
          type: "پورت خصوصی",
          icon: "diagram3",
          value: ""
        },
        {
          id: "publicHost",
          type: "هاست عمومی",
          icon: "tv",
          value: "cv9.ir"
        },
        {
          id: "publicPort",
          type: "پورت عمومی",
          icon: "diagram3",
          value: ""
        }
      ],
      counter: 0,
      remainingTime: "",
      timeout: true,
      timerInterval: null
    };
  },
  mounted() {
    this.getDetailsDb();
  },
  methods: {
    dismissedErrorCreateDbManager: function() {
      this.showErrorCreateDbManager = false;
    },
    createDbManager: async function() {
      this.loadingCreateDbManager = true;
      const [err, d] = await getLastServiceVersionId("phpmyadmin");
      if (err) {
        this.errorMessagesCreateDbManager = err;
        this.showErrorCreateDbManager = true;
        this.loadingCreateDbManager = false;
      } else {
        if (d.apiStatus === 200) {
          const [error, data] = await createService({
            serviceId: d.apiData.versionId,
            dbServiceId: this.$route.params.serviceId,
            cpu: 1,
            ram: 1,
            storage: 1,
            backupType: 1
          });
          if (error) {
            this.errorMessagesCreateDbManager = error;
            this.showErrorCreateDbManager = true;
            this.loadingCreateDbManager = false;
          } else {
            if (data.apiStatus === 200) {
              this.loadingCreateDbManager = false;
              this.getDetailsDb();
            } else {
              this.errorMessagesCreateDbManager = data.apiErrors;
              this.showErrorCreateDbManager = true;
              this.loadingCreateDbManager = false;
            }
          }
        } else {
          this.errorMessagesCreateDbManager = d.apiErrors;
          this.showErrorCreateDbManager = true;
          this.loadingCreateDbManager = false;
        }
      }
    },
    timer: function() {
      if (this.counter > 0) {
        this.counter--;
        this.remainingTime = timerMinScound(this.counter);
      } else {
        this.timeout = true;
      }
    },
    /************************************* */
    getDetailsDb: async function() {
      this.loading = true;
      const [error, data] = await userServiceDetails(
        this.$route.params.serviceId
      );
      if (error) {
        this.errorMessages = error;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          // connect Db
          let tempConnectDbList = [...this.connectDbList];
          tempConnectDbList.map(item => {
            switch (item.id) {
              case "dbManagerName":
                item["value"] = data.apiData.dbManagerName;
                if (data.apiData.dbManagerName) {
                  this.timeout = false;
                  const dateNow = Date.now();
                  let diffTime = data.apiData.dbManagerExpiresIn - dateNow;
                  this.counter = parseInt(diffTime / 1000);
                  this.timerInterval = setInterval(this.timer, 1000);
                }
                break;
              case "password":
                item["value"] = data.apiData.password;
                break;
            }
          });
          this.connectDbList = [...tempConnectDbList];
          // resource List
          let tempResourceList = [...this.resourceList];
          tempResourceList.map(item => {
            switch (item.id) {
              case "ram":
                item["value"] = data.apiData.ram;
                break;
              case "cpu":
                item["value"] = data.apiData.cpu;
                break;
              case "storage":
                item["value"] = data.apiData.storage;
                break;
            }
          });
          this.resourceList = [...tempResourceList];
          // more Info List
          let tempMoreInfoList = [...this.moreInfoList];
          tempMoreInfoList.map(item => {
            switch (item.id) {
              case "price":
                item["value"] = data.apiData.price;
                break;
              case "createdAt":
                item["value"] = data.apiData.createdAt;
                break;
            }
          });
          this.moreInfoList = [...tempMoreInfoList];
          // main Info List
          let tempMainInfoList = [...this.mainInfoList];
          tempMainInfoList.map(item => {
            switch (item.id) {
              case "name":
                item["value"] = data.apiData.name;
                break;
              case "privateHost":
                item["value"] = data.apiData.name;
                break;
              case "privatePort":
                item["value"] = data.apiData.privatePort;
                break;
              case "publicPort":
                item["value"] = data.apiData.publicPort;
                break;
              case "version":
                item["value"] = data.apiData.version;
                break;
            }
          });
          this.mainInfoList = [...tempMainInfoList];
          this.loading = false;
        } else {
          this.errorMessages = data.apiErrors;
          this.loading = false;
        }
      }
    }
  },
  destroyed() {
    clearInterval(this.timerInterval);
  }
};
</script>

<style lang="scss">
.details-image-layout {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.details-image-layout-btn {
  justify-content: center;
  width: 100%;
  display: flex;
}
.details-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
.details-image {
  width: 90%;
  margin-bottom: 20px;
}
</style>
